import { TRUTHY_VALUES } from './constants';

export const getManualBackgroundCheck = (isManualBGC: boolean): boolean => TRUTHY_VALUES.includes(isManualBGC);
